import React from 'react';
function Reset({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5.293 12.905a7.994 7.994 0 112.289 4.741M2.783 9.234l2.51 3.67 3.324-3.056"
      />
    </svg>
  );
}

export default Reset;
